import { useState, useCallback } from "react";

function useModalCreator() {
	let [show, setShowModal] = useState(false);
	// - content
	// - type: WARN, INFO, SUCCESS, VALIDATION
	let [modalConfiguration, setModalConfiguration] = useState(null);

	const showModal = useCallback((content = false) => {
		if (content) {
			setModalConfiguration(content);
		}
		setShowModal(true);
	}, []);

	const onClose = useCallback(() => {
		setShowModal(false)
	}, []);

	return { show, showModal, onClose, modalConfiguration };
};

export default useModalCreator